import styled from 'styled-components';

export const Divider = styled.div`
  margin-top: 0;
`;

export const SmallDivider = styled.div`
  margin-top: 20px;

  @media (max-width: 480px){
    margin-top: -20px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  input {
    @media (max-width: 480px){
      width: 100%;
    }
  }
`;

export const Image = styled.div`
  // display: flex;
  // justify-content: center;

  img {
    max-width: 100%;
  }
  margin-top: 20px;
  text-align: center;
`;

export const ListImageHead = styled.div`
  max-width: 20%;
  margin: 0 auto;

  img {
    max-width: 300px;
  }
`;


export const DetailInfoWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  alingn-items: center;
  @media (max-width: 660px){
    flex-direction: column;
  }

  img {
  max-width: 300px;
  min-width: 200px;
  @media (max-width: 660px){
    margin-bottom: 20px;
    margin-left: 20%;
  }
  @media (max-width: 450px){
    max-width: 200px;
  }
  }
`;


export const DetailList = styled.ul`
  font-size: 18px;
  margin-left: 50px;
  @media (max-width: 480px){
    font-size: 14px;
  }
  li:first-child {
   padding-top: 0;
}
  li {
    padding: 10px 0;
    border-bottom: 1px solid #fff;

    span {
      font-weight: 700;
    }
  }
`;


// WEBPACK FOOTER //
// ./src/system/management/components.js